import { useSelector } from 'react-redux';
import { CartesianGrid, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import styles from './styles.module.scss';
import MetricChartTooltip from './MetricChartTooltip.jsx';
import { MetricChartDotRadius, MetricChartXAxisHeight, MetricChartYAxisWidth } from './constants/index.jsx';
import { MetricChartHeader } from './index.jsx';
import { BreakpointMobile } from '../../constants/ui';
import { ChartColorsMap } from '../Charts/constants/index.jsx';

const ChartTooltip = ({ active, payload, sensor }) => {
  if (!active || !payload || payload.length < 1) return null;
  const value = payload[0].value;
  const valueCompared =
    payload.length > 1
      ? [
          { name: sensor.name, value: `${value}%`, color: ChartColorsMap.soil },
          {
            name: sensor.name2,
            value: `${payload[1].value}%`,
            color: ChartColorsMap.soilCompared,
          },
        ]
      : null;
  return value !== null && <MetricChartTooltip value={`${value}%`} comparedData={valueCompared} />;
};

const MetricChartSoilMoisture = ({ title, data, sensor, widthViewport }) => {
  const { selectedSecondarySensor } = useSelector((state) => state.sensors);

  if (!data) {
    return null;
  }

  return (
    <div className={styles.metricChart}>
      {widthViewport > BreakpointMobile && (
        <MetricChartHeader
          title={title}
          sensorName={sensor.name}
          sensorNameCompared={sensor.name2}
          color={ChartColorsMap.humidity}
          colorCompared={ChartColorsMap.humidityCompared}
          showDeep={true}
        />
      )}

      <ResponsiveContainer width="100%" height={140} className="chart-report">
        <ComposedChart
          width={500}
          height={140}
          data={data.data}
          margin={{
            top: 8,
            right: 8,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="0 0" stroke={'var(--neutral-8)'} vertical={false} />
          <XAxis dataKey="date" tickLine={false} height={MetricChartXAxisHeight} />
          <YAxis ticks={[0, 50, 100]} tickSize={0} tickMargin={6} width={MetricChartYAxisWidth} domain={[0, 100]} />
          <Tooltip content={<ChartTooltip sensor={sensor} />} />
          <Line
            type="monotone"
            dataKey="value"
            strokeWidth={2}
            stroke={ChartColorsMap.soil}
            activeDot={{ r: MetricChartDotRadius, fill: '#fff', stroke: ChartColorsMap.soil }}
          />
          {selectedSecondarySensor && (data.data[0].value2 || data.data[0].value2 === 0) && (
            <Line
              type="monotone"
              dataKey="value2"
              strokeWidth={2}
              stroke={ChartColorsMap.soilCompared}
              strokeDasharray="2 2"
              activeDot={{ r: MetricChartDotRadius, fill: '#fff', stroke: ChartColorsMap.soilCompared }}
            />
          )}
        </ComposedChart>
      </ResponsiveContainer>
      <div className={styles.metricChartUnit}>%</div>
    </div>
  );
};

export default MetricChartSoilMoisture;
